import { render, staticRenderFns } from "./InfoBoxPanelField.vue?vue&type=template&id=60f36af4&scoped=true"
import script from "./InfoBoxPanelField.vue?vue&type=script&lang=js"
export * from "./InfoBoxPanelField.vue?vue&type=script&lang=js"
import style0 from "./InfoBoxPanelField.vue?vue&type=style&index=0&id=60f36af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f36af4",
  null
  
)

export default component.exports